export default __webpack_public_path__ + "static/how-hometown-works-icon-3-e7ad4ac62a3ce75b5ff6c3deb4ff5bae.png";